import React from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { Link } from 'react-scroll';

const AppNavbar = () => {
  return (
    <Navbar bg="light" expand="lg" sticky="top" style={{ boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
      <Container>
        <Navbar.Brand href="#home" style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: '700', color: '#0a4a7d' }}>
          <img
            src="/images/orm_logo.jpeg"
            height="30"
            className="d-inline-block align-top"
            alt="ORM Trust logo"
          />
          {' ORM Trust'}
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto" style={{ fontFamily: 'Montserrat, sans-serif' }}>
            <Nav.Link as={Link} to="home" spy={true} smooth={true} offset={-70} duration={300}>Home</Nav.Link>
            <Nav.Link as={Link} to="about" spy={true} smooth={true} offset={-70} duration={300}>About Us</Nav.Link>
            <Nav.Link as={Link} to="vision" spy={true} smooth={true} offset={-70} duration={300}>Vision</Nav.Link>
            <Nav.Link as={Link} to="gallery" spy={true} smooth={true} offset={-70} duration={300}>Gallery</Nav.Link>
            <Nav.Link as={Link} to="donate" spy={true} smooth={true} offset={-70} duration={300}>Donate Now</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default AppNavbar;